<template>
  <main id="admin-content">
    <b-container fluid class="login-form-container">
      <div class="full-page-wrap">
        <div class="full-page-content login">
          <img class="logo" src="@/assets/img/logo.png" alt="Logo Proeduca" />
          <div class="login-options">
            <div class="user-login-form">
              <button
                type="button"
                class="button large -outline expanded ng-scope"
                @click="loginOauth()"
              >
                {{ $t("buttons.login") }}
              </button>
            </div>
            <a
              href="https://www.grupoproeduca.com"
              target="_blank"
              class="legal"
              >©{{ new Date().getFullYear() }} Grupo Proeduca. Todos los
              derechos reservados.</a
            >
          </div>
        </div>
      </div>
    </b-container>
  </main>
</template>

<script>
import { url } from "@/http-common";
export default {
  name: "LoginAdmin",
  methods: {
    loginOauth() {
      window.location.assign(`${url}/unir-login`);
    },
  },
};
</script>
